import * as React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import {
    Typography,
} from '@material-ui/core';
import { TopActionBar, TaskName, VimoTaskContent } from '../../common/components';
import { getSkillDescriptionTask } from '../../common/utils/programUtils';
// import AboutTheExercises from '../program/components/AboutTheExercises';

import urls from '../../app/urls';
import { Image } from '../../youwell-common/components';
import { isNullOrUndefined } from '../../youwell-common/stringUtils';

const styles = theme => ({
    root: {

    },
    content: {
        padding: theme.spacing(4),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    tasksHeader: {
        marginTop: theme.spacing(4),
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        background: theme.colors.grey2,
    },
    stepHeading: {
        minHeight: theme.spacing(3),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    steps: {
        display: 'flex',
        padding: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    step: {
        flex: '1 1 auto',
        padding: theme.spacing(1),
    },
    borderLeft: {
        borderLeft: theme.borders.normal,

        [theme.breakpoints.down('xs')]: {
            borderLeft: 0,
        },
    },
    taskContentContainer: {
        display: 'flex',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },
    },
    skillDescription: {
        flex: '1 1 auto',
    },
    imageContainer: {
        width: `calc(50% - ${theme.spacing(1)}px)`,
        marginLeft: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            width: `calc(100% - ${theme.spacing(4)}px)`,
            margin: theme.spacing(2),
        },
    },
    image: {
        width: '100%',
    },
    task: {
        padding: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        marginBottom: theme.spacing(2),

        '&:hover': {
            background: theme.colors.grey1,
        },
    },
    aboutTasks: {
        margin: theme.spacing(3),
        marginTop: theme.spacing(10),

        [theme.breakpoints.down('xs')]: {
            margin: 0,
            marginTop: theme.spacing(10),
        },
    },
    aboutTasksHeader: {
        margin: theme.spacing(1),
        marginBottom: theme.spacing(2),
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        background: theme.colors.grey2,
    },
});

class Skill extends React.Component {
    render() {
        const {
            classes, skillData, translate, match,
        } = this.props;

        if (!skillData) {
            return null;
        }

        const { code } = match.params;

        const descriptionTask = getSkillDescriptionTask(skillData);

        const steps = skillData.tasks.reduce((prev, curr) => (
            {
                ...prev,
                [curr.label]: prev[curr.label] ? [...prev[curr.label], curr] : [curr],
            }
        ), {});

        const stepWidth = 100 / Object.entries(steps).length;

        return (
            <div className={classes.root}>
                <TopActionBar
                    title={skillData.name}
                    backLink={{
                        to: `${urls.studentCode.home}/${code}`,
                        text: translate('student.backToOverview'),
                    }}
                />

                <div className={classes.content}>
                    {descriptionTask && (
                        <>
                            <Typography variant="h6" gutterBottom>
                                {descriptionTask.name}
                            </Typography>
                            <div className={classes.taskContentContainer}>
                                <VimoTaskContent task={descriptionTask} className={classes.skillDescription} />
                                {descriptionTask.imageUrl && (
                                    <div className={classes.imageContainer}>
                                        <Image
                                            src={descriptionTask.imageUrl}
                                            alt=""
                                            className={classes.image}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    <Typography variant="h6" className={classes.tasksHeader}>
                        {translate('program.availableTasks')}
                    </Typography>

                    <div className={classes.steps}>
                        {Object.entries(steps).map(([name, tasks], index) => (
                            <div key={name} className={classnames(classes.step, { [classes.borderLeft]: index > 0 })} style={{ flexBasis: `${stepWidth}%` }}>
                                <Typography variant="h6" className={classes.stepHeading}>
                                    {isNullOrUndefined(name) ? '' : name}
                                </Typography>
                                {tasks?.map(task => (
                                    <Link to={`${urls.studentCode.home}/${code}/${urls.studentCode.parts.skill}/${skillData.id}/${urls.studentCode.parts.task}/${task.id}`} key={task.id}>
                                        <TaskName task={task} className={classes.task} />
                                    </Link>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                {/* <div className={classes.aboutTasks}>
                    <Typography variant="h6" className={classes.aboutTasksHeader}>
                        {translate('methodsAndTechniques.aboutTheExercisesHeading')}
                    </Typography>

                    <AboutTheExercises />
                </div> */}

            </div>
        );
    }
}

Skill.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            code: PropTypes.string.isRequired,
            skillId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    skillData: PropTypes.object,
};

Skill.defaultProps = {
    skillData: null,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    skillData: state.program.skillDetails && state.program.skillDetails[ownProps.match.params.skillId],
});

export default connect(mapStateToProps)(withStyles(styles)(Skill));
